import { useTexts, useAppSelector } from "../hooks";
import classes from "../styles/Title.module.css";
import { getClasses } from "../utils";

const Title: React.FC<{ visible?: boolean }> = ({ visible }) => {
  const { custom } = useTexts();
  const name = useAppSelector((state) => state.details.gameName);

  if (typeof visible === "boolean" && !visible) return null;

  return (
    <div className={getClasses(classes, "title", "color", "text-white")}>
      {custom.title || name}
    </div>
  );
};

export default Title;
